<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Draggable {{formatString(sliderType)}} Slider Image List</div>
                <button type="submit" v-on:click.prevent="addSlider" class="btn btn-primary pull-right">Add</button>
                <div v-if="sliderType == 'benefit' || sliderType == '401k'" class="col-xs-12 col-sm-12 col-md-3 col-lg-3 pull-right">
                    <v-select v-model="locationType"
                              name="locationType"
                              id="locationType"
                              label="text"
                              :clearable="false"
                              :searchable="false"
                              :filterable="false"
                              :options="locationTypeArr"
                              placeholder="Select Location Type">
                    </v-select>
                </div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Card with Image-->
                <div class="cards-container">
                    <draggable v-model="imageList" v-on:change="changePosition()" class="drag-view">
                        <template v-for="(text, index) in imageList">
                            <div class="col-4 mb-5">
                                <div class="cards-block">
                                    <div class="card">
                                        <img class="card-img-top" :src="text.image" :key="index" >
                                        <div class="card-body">
                                            <button class="ml-2 mr-2 btn btn-danger pull-right"  v-on:click.prevent="deleteSliderImage(text.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                            <router-link class=" btn btn-primary pull-right" :title="'Edit ' + formatString(sliderType) + ' Slider'" v-bind:to="{name: 'UpdateSlider',params:{id:text.id,type:sliderType}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </draggable>
                </div>
            </div>
        </div>
        <!--page content-->
        <app-backend-footer></app-backend-footer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import vSelect from 'vue-select';
    import draggable from 'vuedraggable';
    import BackendFooter from '@/components/backend/partials/Footer';
    import Vue from "vue";
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    var self;
    export default {
        name: 'List_Media',
        mixins: [SessioMixin],
        components: {
            draggable,
            'v-select': vSelect,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                locationType: {value: 'other', text: 'Other'},
                locationTypeArr: [
                    {value: 'other', text: 'Other'},
                    {value: 'Velocity SBA', text: 'Velocity SBA'}
                ],
                sliderType: '',
                imageList: [],
                imagePosition: [],
            }
        },
        computed: {

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.showLoader();
            self.sliderType = this.$route.params.type;
            self.getImages();
        },
        watch: {
            '$route'() {
                self.sliderType = this.$route.params.type;
                self.locationType = {value: 'other', text: 'Other'};
                self.getImages();
            },
            locationType: function (locationType) {
                self.getImages();
            },
        },
        methods: {
            addSlider() {
                self.$router.push('/backend/addslider/' + self.sliderType);
            },
            deleteSliderImage: function (id) {
                //console.log(id);
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        delete: id,
                        'type': self.sliderType,
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("deletesliderimage", config)
                                .then(function (response) {
                                    self.getImages();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        self.$swal('Deleted', 'You successfully deleted the slide.', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your slide still intact', 'info')
                    }
                });
            },
            getImages() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': self.sliderType,
                        'location_type': self.locationType.value,
                    }
                };
                /*var fields = {
                 limit: 2,
                 };*/
                self.showLoader();
                HTTP.get("getsliderimage", config)
                        .then(function (response) {
                            self.imageList = response.data.content;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            changePosition() {
                var fields = {
                    imageList: self.imageList,
                    'type': self.sliderType,
                    'location_type': self.locationType.value,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("changepositionslider", fields, config)
                        .then(function (response) {
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/slider/ListSlider.vue